// PinIcon.js
import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbtack } from '@fortawesome/free-solid-svg-icons';
import '../css/pinIcon.css';  // Importing a CSS file to handle the animation
import { toast } from 'react-toastify';

const PinIcon = ({ pinned, togglePin }) => {
    const [isTransitioning, setIsTransitioning] = useState(false);
    const [pinState, setPinState] = useState(pinned);
  
    const handlePinClick = () => {
      setIsTransitioning(true);
      // onPinToggle();  // Call the provided onPinToggle function to update the pinned state
      setPinState(!pinState);

      // delay executing this function until the transition is complete
      setTimeout(() => {
        if (!pinState) {
            togglePin(!pinState);
            // toast.success('Pinned', { theme: 'colored'});
        } else {
            togglePin(pinState);
            // toast.success('Unpinned', { theme: 'colored'});
        }
      }, 1000);
    };
  
    useEffect(() => {
      if (isTransitioning) {
        // Reset the transitioning state after the animation duration
        const timeoutId = setTimeout(() => setIsTransitioning(false), 200);
        return () => clearTimeout(timeoutId);  // Clean up the timeout on component unmount
      }
    }, [isTransitioning]);
  
    return (
      <div className={`pin-icon ${isTransitioning ? 'transitioning' : ''}`} onClick={handlePinClick}>
        <FontAwesomeIcon
          icon={faThumbtack}
          className={`pin ${pinState ? 'pinned' : 'unpinned'}`}
        />
      </div>
    );
  };

export default PinIcon;
